import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-send-email-preview',
  templateUrl: './send-email-preview.component.html',
  styleUrls: ['./send-email-preview.component.scss']
})
export class SendEmailPreviewComponent implements OnInit {
  @Input() previewData: {
    params: {
      to: string;
      subject: string;
      body: string;
      recipients: string[];
    }
    tool_name: string;
  };
  @Input() actionData: any;

  ngOnInit() {
    console.log('SendEmailPreviewComponent initialized');
    console.log('previewData:', this.previewData);
    console.log('actionData:', this.actionData);
    console.log('emailData:', this.emailData);
  }

  get emailData() {
    return this.previewData || this.actionData || {};
  }
}
